import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { auth } from './firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import { Capacitor } from '@capacitor/core';
import { Purchases, LOG_LEVEL } from '@revenuecat/purchases-capacitor';

import BottomNav    from './components/BottomNav';
import Dashboard    from './pages/Dashboard';
import Games        from './pages/Games';
import DailyBonus   from './pages/DailyBonus';
import Leaderboards from './pages/Leaderboards';
import Profile      from './pages/Profile';
import Shop         from './pages/Shop';
import Wallet       from './pages/Wallet';
import Marketplace     from './pages/Marketplace';
import TermsOfService  from './pages/TermsOfService';
import PrivacyPolicy   from './pages/PrivacyPolicy';
import SafetyPolicy    from './pages/SafetyPolicy';
import LoginPage       from './pages/LoginPage';

import { ThemeProvider } from './contexts/ThemeContext';
import { SessionProvider } from './contexts/SessionContext';
import ThemeToggle from './components/ThemeToggle';
import './styles/global.css';

function AuthGuard({ user, children }) {
  if (user === undefined) return null; // auth loading
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

// Renders the theme toggle; knows whether the bottom nav is present
function FloatingThemeToggle() {
  const { pathname } = useLocation();
  const noNav = pathname === '/login' || pathname === '/terms' || pathname === '/privacy' || pathname === '/safety';
  return <ThemeToggle noNav={noNav} />;
}

export default function App() {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    return onAuthStateChanged(auth, u => setUser(u || null));
  }, []);

  useEffect(() => {
    async function configureRevenueCat() {
      const platform = Capacitor.getPlatform();
      if (platform === 'android' || platform === 'ios') {
        await Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG });
        await Purchases.configure({ apiKey: process.env.REACT_APP_REVENUECAT_KEY });
      }
    }
    configureRevenueCat();
  }, []);

  return (
    <ThemeProvider>
    <SessionProvider>
    <BrowserRouter>
      <div className="app-shell">
        <FloatingThemeToggle />
        <Routes>
          <Route path="/login" element={
            user ? <Navigate to="/" replace /> : <LoginPage />
          } />

          {/* Public — accessible without login */}
          <Route path="/terms" element={<TermsOfService />} />

          <Route path="/*" element={
            <AuthGuard user={user}>
              <>
                <Routes>
                  <Route path="/"             element={<Dashboard />} />
                  <Route path="/games"        element={<Games />} />
                  <Route path="/daily-bonus"  element={<DailyBonus />} />
                  <Route path="/leaderboards" element={<Leaderboards />} />
                  <Route path="/profile"      element={<Profile />} />
                  <Route path="/shop"         element={<Shop />} />
                  <Route path="/wallet"       element={<Wallet />} />
                  <Route path="/marketplace"  element={<Marketplace />} />
                  <Route path="/terms"        element={<TermsOfService />} />
                  <Route path="/privacy"      element={<PrivacyPolicy />} />
                  <Route path="/safety"       element={<SafetyPolicy />} />
                  <Route path="*"             element={<Navigate to="/" replace />} />
                </Routes>
                <BottomNav />
              </>
            </AuthGuard>
          } />
        </Routes>
      </div>
    </BrowserRouter>
    </SessionProvider>
    </ThemeProvider>
  );
}
